export const SITE_URL = (
  process.env.NEXT_PUBLIC_SITE_URL ??
  process.env.SITE_URL ??
  "https://softiq.cz"
).replace(/\/$/, "");

export const SITE_NAME = "SOFTIQ";
export const SITE_TITLE = "Správa realitního portfolia | SOFTIQ";
export const SITE_DESCRIPTION =
  "Vyzkoušejte SOFTIQ a spravujte hodnotu, finance, dokumenty i důležité termíny svého realitního portfolia. Hlídací pes sleduje nové příležitosti.";
export const DEFAULT_OG_IMAGE = "/image/cta/web-banner.png";

export const PORTFOLIO_KEYWORDS = [
  "správa nemovitostí",
  "správa realitního portfolia",
  "realitní portfolio",
  "evidence nemovitostí",
  "software pro správu nemovitostí",
  "aplikace pro správu nemovitostí",
  "správa nájemních nemovitostí",
  "finance nemovitostí",
  "příjmy a výdaje z nemovitostí",
  "správa dokumentů k nemovitostem",
  "realitní hlídací pes",
  "hlídací pes na nemovitosti",
] as const;

export const HOME_FAQ = [
  {
    question: "Jak funguje správa nemovitostí v SOFTIQ?",
    answer:
      "Každou nemovitost přidáte do svého portfolia a získáte společný přehled o její hodnotě, příjmech, výdajích, dokumentech a důležitých termínech.",
  },
  {
    question: "Jaké finance mohu u nemovitostí evidovat?",
    answer:
      "U nemovitostí můžete sledovat příjmy, výdaje a jejich vývoj v čase. SOFTIQ vám pomůže udržet finance jednotlivých nemovitostí i celého portfolia v jednom přehledu.",
  },
  {
    question: "Mohu v SOFTIQ spravovat více nemovitostí?",
    answer:
      "Ano. Počet nemovitostí v portfoliu se odvíjí od zvoleného členství, takže můžete začít s jednou nemovitostí a později portfolio rozšiřovat.",
  },
  {
    question: "Jak hlídací pes doplňuje správu portfolia?",
    answer:
      "Když chcete portfolio rozšířit, nastavíte lokalitu, typ nemovitosti, cenu a další kritéria. SOFTIQ potom sleduje nové a aktualizované nabídky na realitních portálech.",
  },
] as const;

export function absoluteUrl(pathname = "/") {
  return new URL(pathname, `${SITE_URL}/`).toString();
}

export function serializeStructuredData(data: unknown) {
  return JSON.stringify(data).replace(/</g, "\\u003c");
}
